import Nullable from '@/types/nullable';
import SuitabilityAnalysisPortfolio from '@/types/suitability-analysis-portfolio';

export type SuitabilityAnalysisState = Nullable<SuitabilityAnalysisPortfolio[]>;

export enum SuitabilityAnalysisResultType {
  ERROR_PRODUCT_NOT_FOUND = 'ErrorProductNotFound',
  ERROR_RISK_PROFILE_NOT_FOUND = 'ErrorRiskProfileNotFound',
  OK = 'OK',
  REVIEW_REQUIRED = 'ReviewRequired',
}
